import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../lib/api.js';

export default function ChickensNew() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    type: 'broiler',
    name: '',
    source: '',
    source_date: new Date().toISOString().slice(0, 10),
    count_in: '',
    expected_processing_date: '',
    notes: '',
  });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  function set(k, v) { setForm(f => ({ ...f, [k]: v })); }

  async function submit(e) {
    e.preventDefault();
    setBusy(true); setErr('');
    try {
      const body = {
        type: form.type,
        name: form.name.trim(),
        source: form.source.trim() || null,
        source_date: form.source_date || null,
        count_in: form.count_in ? Number(form.count_in) : null,
        expected_processing_date: form.expected_processing_date || null,
        notes: form.notes.trim() || null,
      };
      const { id } = await api.post('/api/chickens', body);
      navigate(`/chickens/${id}`);
    } catch (e) { setErr(e.message); }
    finally { setBusy(false); }
  }

  return (
    <form onSubmit={submit} className="space-y-4 max-w-xl">
      <h1 className="text-2xl font-serif text-olive-900">Add Batch / Flock</h1>

      <div className="card grid grid-cols-2 gap-3">
        <div className="col-span-2">
          <label className="label">Type</label>
          <div className="grid grid-cols-2 gap-2 mt-1">
            <button
              type="button"
              onClick={() => set('type', 'broiler')}
              className={`card text-center py-3 ${form.type === 'broiler' ? 'ring-2 ring-olive-500' : ''}`}
            >
              <div className="text-2xl">🍗</div>
              <div className="text-sm font-medium mt-1">Broiler batch</div>
              <div className="text-xs text-ink-700/60">finite run, processing date</div>
            </button>
            <button
              type="button"
              onClick={() => set('type', 'layer')}
              className={`card text-center py-3 ${form.type === 'layer' ? 'ring-2 ring-olive-500' : ''}`}
            >
              <div className="text-2xl">🥚</div>
              <div className="text-sm font-medium mt-1">Layer flock</div>
              <div className="text-xs text-ink-700/60">rolling, mortality + replacements</div>
            </button>
          </div>
        </div>
        <div className="col-span-2">
          <label className="label">Name *</label>
          <input className="input" required value={form.name} onChange={e => set('name', e.target.value)} placeholder={form.type === 'broiler' ? 'Spring 2026 Run' : 'Main Coop'} />
        </div>
        <div className="col-span-2">
          <label className="label">Source</label>
          <input className="input" value={form.source} onChange={e => set('source', e.target.value)} placeholder="Murray McMurray, local hatchery, etc." />
        </div>
        <div>
          <label className="label">Source date</label>
          <input className="input" type="date" value={form.source_date} onChange={e => set('source_date', e.target.value)} />
        </div>
        <div>
          <label className="label">Count in</label>
          <input className="input" type="number" min="0" value={form.count_in} onChange={e => set('count_in', e.target.value)} placeholder={form.type === 'broiler' ? '100' : '25'} />
        </div>
        {form.type === 'broiler' && (
          <div className="col-span-2">
            <label className="label">Expected processing date</label>
            <input className="input" type="date" value={form.expected_processing_date} onChange={e => set('expected_processing_date', e.target.value)} />
          </div>
        )}
        <div className="col-span-2">
          <label className="label">Notes</label>
          <textarea className="input" rows={2} value={form.notes} onChange={e => set('notes', e.target.value)} />
        </div>
      </div>

      {err && <div className="bg-rust-500/10 text-rust-700 rounded-md px-3 py-2 text-sm">{err}</div>}

      <div className="flex gap-2">
        <button type="button" onClick={() => navigate('/chickens')} className="btn-ghost">Cancel</button>
        <button className="btn-primary" disabled={busy}>{busy ? 'Saving…' : 'Save'}</button>
      </div>
    </form>
  );
}
